import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MaintenanceRequestWithRelations } from "@/types/maintenance";

interface MaintenanceState {
  maintenanceRequests: MaintenanceRequestWithRelations[];
  loading: boolean;
  error: string | null;
}

const initialState: MaintenanceState = {
  maintenanceRequests: [],
  loading: false,
  error: null,
};

const maintenanceSlice = createSlice({
  name: "maintenance",
  initialState,
  reducers: {
    setMaintenanceRequests: (
      state,
      action: PayloadAction<MaintenanceRequestWithRelations[]>,
    ) => {
      state.maintenanceRequests = action.payload;
    },
    setMaintenanceRequestsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setMaintenanceRequestsError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    removeMaintenanceRequest: (state, action: PayloadAction<string>) => {
      state.maintenanceRequests = state.maintenanceRequests.filter(
        (request) => request.id !== action.payload,
      );
    },
    updateMaintenanceRequest: (
      state,
      action: PayloadAction<MaintenanceRequestWithRelations>,
    ) => {
      const index = state.maintenanceRequests.findIndex(
        (request) => request.id === action.payload.id,
      );
      if (index !== -1) {
        state.maintenanceRequests[index] = action.payload;
      }
    },
  },
});

export const {
  setMaintenanceRequests,
  setMaintenanceRequestsLoading,
  setMaintenanceRequestsError,
  removeMaintenanceRequest,
  updateMaintenanceRequest,
} = maintenanceSlice.actions;

export default maintenanceSlice.reducer;
